import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals'
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const EditCancelPolicy = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [cancelDetails, setCancelDetails] = useState('');
    const cancelTitle = 'Cancel Policy';

    const fetchData = useCallback(async () => {
        await getApi(endPoints.getsCancelbyid(id), {
            setResponse: (response) => {
                setCancelDetails(response?.data?.description || ''); // Initialize textarea value
            },
            setLoading,
            errorMsg: 'Failed to fetch data!',
        });
    }, [id]);


    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSubmit = async () => {
        const payload = {
            title: cancelTitle,
            description: cancelDetails,
        };

        await postApi(endPoints.addcancel, payload, {
            setLoading,
            errorMsg: 'Failed to update cancel policy!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/cancelpolicy'); // Redirect to the Privacy Policy list page
        }, 2000);
    };
    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Updated"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Edit Cancel Policy</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Cancel Policy</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Cancel Policy Details</h6>
                        </div>
                        <div className={addjob.editprivacypolicy}>
                            <label htmlFor="policyDetails">Edit Cancel Policy Details*</label>
                            <textarea
                                id="policyDetails"
                                placeholder="Edit the cancel policy details here..."
                                value={cancelDetails}
                                onChange={(e) => setCancelDetails(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update"}
                            </button>
                        </div>
                    </div>

                </div>

            </div >
        </>
    )
}

export default HOC(EditCancelPolicy)